import { styled } from '@mui/material/styles'
import { Box } from '@mui/material'

export const GridWrapper = styled(Box)(({ theme }) => (`
    padding-top:10px;
    width:100%;
`))

export const TableWrapper = styled(Box)(({ theme }) => (`
    & th, & td { cursor:pointer; padding: 5px 10px; color: ${theme.components.GridList.styleOverrides.color} !important;}
    & tr { transition: ${theme.transition}; }
    & .actionWrapper { padding:0; }
    & tr:nth-of-type(even) {
        background-color: ${theme.components.GridList.styleOverrides.tdOddBackground};
    }
    & tbody tr:hover {
        background-color: ${theme.components.GridList.styleOverrides.tdHoverBackground} !important;
    }
    & thead tr { border-bottom: 2px ${theme.components.GridList.styleOverrides.tdHoverBackground} solid;}
    & thead th { cursor:default !important;}
`))
